module.exports = __webpack_public_path__ + "img/c325c14.jpg";